import React, { useMemo, useState, useEffect, memo, useCallback } from "react";

import * as SC from "./PrintPostPreview.styled";

import _ from "lodash";

import logger from "../../../../../utils/LoggerFrontend";
import database from "../../../../../utils/FirebaseController";
import PrintPostEditorSwitch from "../print-post-editor-switch/PrintPostEditorSwitch";

const PrintPostPreview = ({
  selectedPreviewChannel,
  postData,
  channelData,
  selectedPostNumber,
  channelPosts,
  selectedCreativeIndexToEdit,
  mobile
}) => {
  logger.debug("PrintPostPreview:init", "called", {
    selectedPreviewChannel,
    selectedPostNumber,
    selectedCreativeIndexToEdit,
    channelData,
    postData
  });

  const [shouldUseLongImage, setShouldUseLongImage] = useState(false);
  const [mediaAssetsProps, setMediaAssetsProps] = useState([]);

  const mediaAssets = useMemo(
    () => postData.mediaAssets || postData.creatives?.map(() => null),
    [postData]
  );

  const fetchMediaAssets = useCallback(async () => {
    if (mediaAssets && mediaAssets.length > 0) {
      const newMediaAssetsProps = await Promise.all(
        mediaAssets.map(async (mediaAsset) => {
          const mediaAssetData = await database.getMediaAssetWithId(mediaAsset);
          return {
            id: mediaAsset,
            templateId: mediaAssetData.templateId,
            inputProps: mediaAssetData.inputProps
          };
        })
      );

      setMediaAssetsProps(newMediaAssetsProps);
    }
  }, [mediaAssets]);

  useEffect(() => {
    fetchMediaAssets();
  }, [mediaAssets, fetchMediaAssets]);

  useEffect(() => {
    const hasMediaAssets =
      mediaAssetsProps?.length > 0 && mediaAssetsProps?.[selectedCreativeIndexToEdit];

    if (hasMediaAssets) {
      const verticalTemplates = ["ShapeImage", "VerticalImage"];

      const isVerticalTemplate = verticalTemplates.includes(
        mediaAssetsProps?.[selectedCreativeIndexToEdit].templateId
      );

      const isVerticalOrientation =
        mediaAssetsProps?.[selectedCreativeIndexToEdit].inputProps?.orientation === "vertical";

      setShouldUseLongImage(isVerticalTemplate || isVerticalOrientation);
    }
  }, [mediaAssetsProps, selectedCreativeIndexToEdit, shouldUseLongImage, selectedPreviewChannel]);

  const selectedPostId = useMemo(
    () => _.find(channelPosts, ({ postNumber }) => postNumber === selectedPostNumber)?.id,
    [channelPosts, selectedPostNumber]
  );

  return (
    <SC.PostPreviewWrapper>
      <PrintPostEditorSwitch
        selectedPostId={selectedPostId}
        selectedPreviewChannel={selectedPreviewChannel}
        mobile={mobile}
        postData={postData}
        mediaAssetsProps={mediaAssetsProps}
        mediaAssets={mediaAssets}
        channelData={channelData}
        selectedCreativeIndexToEdit={selectedCreativeIndexToEdit}
        shouldUseLongImage={shouldUseLongImage}
      />
    </SC.PostPreviewWrapper>
  );
};

export default memo(PrintPostPreview);
